import { render, staticRenderFns } from "./ClinicFinanceStatement.vue?vue&type=template&id=d748d926"
import script from "./ClinicFinanceStatement.vue?vue&type=script&lang=js"
export * from "./ClinicFinanceStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports